import EmailConfirmation from '@/components/organism/Registration/EmailConfirmation/EmailConfirmation.container';

export const EmailConfirmationPage = () => <EmailConfirmation />;
